import React, { useEffect, useState } from "react"

import { Breadcrumb } from "react-bootstrap";

export default function TCABreadCrumb(props) {

    const prepareBreadCrumb = () => {
        let result = [];
        result.push(<Breadcrumb.Item href="/">Home</Breadcrumb.Item>);
        for (var i = 0; i < props.breadCrumbData.length; i++) {
            if (props.breadCrumbData[i].link) {
                result.push(<Breadcrumb.Item key={i} href={props.breadCrumbData[i].link}>{props.breadCrumbData[i].title}</Breadcrumb.Item>);
            } else {
                result.push(<Breadcrumb.Item key={i} active>{props.breadCrumbData[i].title}</Breadcrumb.Item>);
            }
        }
        return result;
    }

    return (
        <>
            <Breadcrumb>
                {prepareBreadCrumb()}
            </Breadcrumb>
        </>
    );

}